import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

class Footer extends Component {
    render() {
        return (
            <footer>
                <div style={{ backgroundColor: '#9DAF7D', zIndex: '999', width: '100%', height: 'auto' }}>
                    <div className="grid sm:grid-cols-12 gap-5 py-8 md:py-12 border-t border-gray-200 lg:ml-11">
                        <div className="col-span-12 lg:col-span-4">
                            <img 
                                src={`${process.env.PUBLIC_URL}/flogo.png`} 
                                alt="Company Logo" 
                                style={{ width: '40%', height: 'auto', marginLeft: '100px', marginTop: '40px' }} 
                            />
                        </div>

                        <div style={{ marginLeft: '100px' }} className="col-span-6 md:col-span-6 lg:col-span-1 ml-7 mx-auto">
                            <h6 className="text-gray-200 text-xl font-bold mb-4">LIIENS</h6>
                            <ul className="text-md">
                                <li className="mb-2">
                                    <HashLink 
                                        to="#about" 
                                        className="text-red-900 hover:text-gray-700 hover:tracking-wider transition duration-250 ease-in-out" 
                                        style={{ textDecoration: 'none' }}
                                    >
                                        About
                                    </HashLink>
                                </li>
                                <li className="mb-2">
                                    <HashLink 
                                        to="#services" 
                                        className="text-red-900 hover:text-gray-700 hover:tracking-wider transition duration-250 ease-in-out" 
                                        style={{ textDecoration: 'none' }}
                                    >
                                        Services
                                    </HashLink>
                                </li>
                                <li className="mb-2">
                                    <HashLink 
                                        to="#" 
                                        className="text-red-900 hover:text-gray-700 hover:tracking-wider transition duration-250 ease-in-out" 
                                        style={{ textDecoration: 'none' }}
                                    >
                                        CCM
                                    </HashLink>
                                </li>
                                <li className="mb-2">
                                    <HashLink 
                                        to="#" 
                                        className="text-red-900 hover:text-gray-700 hover:tracking-wider transition duration-250 ease-in-out" 
                                        style={{ textDecoration: 'none' }}
                                    >
                                        Contact
                                    </HashLink>
                                </li>
                            </ul>
                        </div>

                        <div className="col-span-6 md:col-span-6 lg:col-span-4 mx-auto">
                            <h6 className="text-gray-200 text-xl font-bold mb-4">NOS SERVICES</h6>
                            <ul className="text-md">
                                <li className="mb-2">
                                    <Link 
                                        to="#" 
                                        className="text-red-900 hover:text-gray-700 hover:tracking-wider transition duration-250 ease-in-out" 
                                        style={{ textDecoration: 'none' }}
                                    >
                                        Vente simplifiée
                                    </Link>
                                </li>
                                <li className="mb-2">
                                    <Link 
                                        to="#" 
                                        className="text-red-900 hover:text-gray-700 hover:tracking-wider transition duration-250 ease-in-out" 
                                        style={{ textDecoration: 'none' }}
                                    >
                                        Livraison rapide
                                    </Link>
                                </li>
                                <li className="mb-2">
                                    <Link 
                                        to="#" 
                                        className="text-red-900 hover:text-gray-700 hover:tracking-wider transition duration-250 ease-in-out" 
                                        style={{ textDecoration: 'none' }}
                                    >
                                        Catalogue varié
                                    </Link>
                                </li>
                                <li className="mb-2">
                                    <Link 
                                        to="#" 
                                        className="text-red-900 hover:text-gray-700 hover:tracking-wider transition duration-250 ease-in-out" 
                                        style={{ textDecoration: 'none' }}
                                    >
                                        Communauté active
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div style={{ textAlign: 'center' }} className="text-sm text-gray-200 font-semibold py-1">
                        Copyright &copy; {new Date().getFullYear()}{"  "}. Tous droits réservés.
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;
